import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {DWPFileContext} from "./context/DWPUploadContext";
import {AlertContext} from "../alert/context/AlertContext";
import {FormattedMessage} from "react-intl";
import {PickContext} from "../pickStatus/context/PickContext";
import {PickFilterContext} from "../pickStatus/context/PickFilterContext";
import  Loader from "@amzn/meridian/loader";
import Column from "@amzn/meridian/column";
import Link from "@amzn/meridian/link";

const DWPUpload = () => {
    const {viewModelDWP,dispatchDWP} = useContext(DWPFileContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {alertDispatch} = useContext(AlertContext)
    const {dispatch} = useContext(PickContext)
    const {viewModelF, dispatchF} = useContext(PickFilterContext)

    const hiddenFileInput = React.useRef(null);

    const uploadDWP = () => {
        hiddenFileInput.current.click();
    }

    function canDWPUploadButtonEnable() {
        return !viewModelDWP.isLoading
    }

    function showLoader() {
        if (viewModelDWP.isLoading) {
            return (
                <Column
                    height="50px"
                    alignmentHorizontal="center"
                >
                    <Loader size="small"/>
                </Column>
            );
        }
    }

    useEffect(() => {
        dispatchDWP({
            type: 'LOAD_DWP_INFO', data: {
                baseUrl: configViewModel.baseUrl,
                dispatcher: dispatchDWP,
                stationConfig: configViewModel.stationConfig
            }
        });
    }, []);

    const uploadFile = (event) => {
        const files = event.target.files;
        dispatchDWP({
            type: 'UPLOAD_DWP',
            data: {
                dispatcher: dispatchDWP,
                baseUrl: configViewModel.baseUrl,
                file: files[0],
                alertDispatch: alertDispatch,
                filterDispatcher: dispatchF,
                xptNodes: viewModelF.xptNodes,
                capability: configViewModel.capability,
                routeDispatcher: dispatch,
                stationConfig: configViewModel.stationConfig
            }
        });
        event.target.value = ''
    }

    return (
        <div>
            <Row spacingInset="none" spacing="none" alignmentHorizontal="left">
                <input ref={hiddenFileInput} type='file' style={{display: 'none'}} onChange={uploadFile}/>
                <Link type="secondary" onClick={uploadDWP} disabled={!canDWPUploadButtonEnable()}>
                    <FormattedMessage id="pick.uploadDwp" defaultMessage="Upload DWP"/>
                    {showLoader()}
                </Link>
            </Row>
        </div>
    )
}

export default DWPUpload


// WEBPACK FOOTER //
// ./src/components/fileupload/DWPUpload.js